import React from 'react'
import { INTERVIEW_STEPS } from 'ducks/router'

// NOTE: hook that handles toggling edit mode
export const useEditMode = ({ handleChangeStep }) => {
  const [isEditMode, setIsEditMode] = React.useState(false)

  const toggleEditMode = React.useCallback(() => {
    if (!isEditMode) {
      handleChangeStep(INTERVIEW_STEPS.SUMMARY)
    }

    setIsEditMode(!isEditMode)
  }, [setIsEditMode, isEditMode, handleChangeStep])

  return {
    state: { isEditMode },
    handlers: { toggleEditMode },
  }
}
